// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import archive from './routes/archive';
import single from './routes/single';
import templateContact from './routes/templateContact';

// Additional Libraries
import { menu } from './modules/menu';

// Swup setup
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';

const scroll_options = {
	doScrollingRightAway: false,
    animateScroll: false,
}

const options = {
	plugins: [
		new SwupBodyClassPlugin(),
		new SwupScrollPlugin(scroll_options),
	],
	containers: [
		'#body-wrapper',
	],
};
const swup = new Swup(options);

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Archive page
  archive,
  // Single pages
  single,
  // Contact page
  templateContact,
});

// Generic events - these are loaded once only and would not re-run on Swup page changes
jQuery(document).ready(() => {
	// Place one off code here - such as click events for the menu
	menu();
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Load Events when using Swup
swup.on('contentReplaced', () => {
	routes.loadEvents();
	setup_gravity_scripts();
});

function setup_gravity_scripts()
{
	//Only find scripts inside the app-container as they are within Swup
	let selector = $('.body-wrapper').find('.gform_wrapper');

	if(selector.length > 0)
	{
		selector.each(function(){
			let scripts = $(this).parent().find('script');
			scripts.each(function(){
				let text = $(this).text();
				eval(text);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./scripts/main.js